import React, { createRef } from "react";
import { Buffer } from "buffer";
import { Menu } from "primereact/menu";
import { formatCurrency } from "../utils/FormatCurrency";
import { parseISO, format } from "date-fns";
import { pdfService } from "../services/PdfService";
import { PegaTermo } from "../services/requests/postPayment";
import { Badge } from "primereact/badge";
import { toast } from "react-toastify";
import { FaDownload, FaFileDownload, FaRegCopy } from "react-icons/fa";
import { GrDownload } from "react-icons/gr";
import { extraiCodigoBarras, montaLinhaDigitavel } from "../utils/CodigoBarrasBoleto";

export function ColunaBoletoBody({ rowData }) {
  const menu = createRef();
  console.log(rowData);

  let listaBoletos = [];
  const boletosNaoPagos = rowData.filter((boletos) => boletos.boleto_status === "not_paid");
  const boletosCancelados = rowData.filter((boletos) => boletos.boleto_status === "canceled");

  if (boletosNaoPagos.length > 0) {
    listaBoletos = boletosNaoPagos.map((boletos) => ({
      label: `Boleto de ${formatCurrency(boletos.boleto_valor)}, 
        Vencimento em ${format(parseISO(boletos.cobranca_data_vencimento), "dd/MM/yyyy")}`,
      value: boletos.boleto_id,
      order: boletos.boleto_order,
      className:
        "text-[min(2vh,1.2rem)] max-[500px]:text-[0.85rem] max-[300px]:text-[0.7rem] font-lato w-full border-0 hover:font-lato-bold",
      //disabled: boletos.boleto_base64 === null,
      icon: "pi pi-download text-blue-700",
      command: () => {
        downloadBoleto(boletos);
      },
      template: (item, options) => {
        // null quando o boleto ainda não foi emitido (depende do pagamento do anterior)
        const linhaDigitavel = montaLinhaDigitavel(extraiCodigoBarras(boletos));

        return (
          <div className="w-full flex flex-col md:flex-row md:items-stretch gap-0 md:gap-[min(1.5vh,0.9rem)] mb-[min(2vh,1.2rem)]">
            <a
              className="w-full min-w-0 flex justify-between p-[min(1.3vh,0.8rem)] max-[500px]:p-[0.4rem] cursor-pointer border-2 bg-white
                 border-blue-900 rounded-xl rounded-b-none border-b-0 md:rounded-b-xl md:border-b-2
                 hover:bg-slate-200 items-center gap-[min(1vh,0.6rem)] max-[500px]:gap-[0.3rem]"
              target={item.target}
              onClick={options.onClick}
            >
              <Badge
                className="shrink-0 max-[500px]:!w-[2.25rem] max-[500px]:!h-[1.25rem] max-[500px]:!text-[0.75rem]
                   max-[300px]:!w-[1.9rem] max-[300px]:!h-[1.1rem] max-[300px]:!text-[0.65rem]"
                value={`${item.order}º`}
                style={{
                  backgroundColor: "red",
                  width: "min(6vh,3.6rem)",
                  height: "min(3.5vh,2.1rem)",
                  fontSize: "min(2.5vh,1.5rem)",
                  display: "grid",
                  alignContent: "center",
                }}
              />
              <span className={`${options.labelClassName} min-w-0 break-words`}>{item.label}</span>
              <FaFileDownload className="shrink-0 text-[min(5vh,3rem)] max-[500px]:text-[1.25rem] max-[300px]:text-[1rem] md:text-[min(3vh,1.8rem)] text-sky-600" />
            </a>
            <button
              className="shrink-0 w-full md:w-[min(10vh,4rem)] flex md:flex-col items-center justify-center
                 gap-[min(1vh,0.6rem)] md:gap-[0.3vh] p-[min(0.8vh,0.5rem)] md:p-0 border-2 bg-white
                 border-blue-900 rounded-xl rounded-t-none md:rounded-t-xl transition duration-200 hover:bg-slate-200
                 disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:bg-white"
              onClick={() => copiarCodigoBarras(linhaDigitavel)}
              disabled={!linhaDigitavel}
              title={linhaDigitavel ? "Copiar código de barras" : "Boleto ainda não emitido"}
              type="button"
            >
              <FaRegCopy className="shrink-0 text-[min(3vh,1.5rem)] max-[500px]:text-[1.25rem] max-[300px]:text-[1rem] text-sky-600" />
              <span className="md:hidden text-[min(2vh,1rem)] max-[300px]:text-[0.75rem] font-lato-bold text-slate-600">
                {linhaDigitavel ? "Copiar código de barras" : "Boleto ainda não emitido"}
              </span>
              <span className="hidden md:inline text-[min(1.5vh,0.75rem)] leading-none text-slate-600">copiar</span>
            </button>
          </div>
        );
      },
    }));
  } else {
    if (boletosCancelados.length > 0)
      listaBoletos = [
        {
          label: "Esta negociação foi cancelada e os boletos estão indisponíveis",
          className: "text-[2vh] font-lato-bold w-full border-0 ",
          value: "null",
          icon: "pi pi-times",
        },
      ];
    else
      listaBoletos = [
        {
          label: "Todos os boletos dessa negociação foram pagos",
          className: "text-[2vh] font-lato-bold w-full border-0 ",
          value: "null",
          icon: "pi pi-check",
        },
      ];
  }

  async function copiarCodigoBarras(linhaDigitavel) {
    // copia formatado, igual ao dialog de negociacao concluida e ao app do credor
    try {
      await navigator.clipboard.writeText(linhaDigitavel);
      toast.success("Código de barras copiado!");
    } catch (error) {
      console.log(error);
      toast.warn("Não foi possível copiar. Baixe o boleto para ver o código de barras.");
    }
  }

  function downloadBoleto(data) {
    if (data.boleto_base64 === null) {
      toast.warn("Há um boleto mais recente não pago, realize o pagamento para liberar o próximo boleto");
    } else {
      const binary = Buffer.from(data.boleto_base64.replace(/\s/g, ""), "base64").toString("binary");
      const len = binary.length;
      const buffer = new ArrayBuffer(len);
      //console.log(binary)
      let view = new Uint8Array(buffer);

      for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
      }
      const blob = new Blob([view], { type: "application/pdf" });
      const boleto = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = boleto;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      link.download = `boleto-vencimento:${format(new Date(data.cobranca_data_vencimento), "dd/MM/yyyy")}.pdf`;
      document.body.appendChild(link);
      link.click();

      if (window.innerWidth <= 800 && window.innerHeight <= 600) {
        const newtab = window.open();
        const html = `
        <!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>PDF to Image Viewer</title>
          <script src="https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js" integrity="sha512-q+4liFwdPC/bNdhUpZx6aXDx/h77yEQtn4I1slHydcbZK34nLaR3cAeYSJshoxIOq3mjEf7xJE8YWIUHMn+oCQ==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
        </head>
        <body>
          <div id="imageContainer"></div>
          <script>

            const pdfUrl = '${boleto}';
            var { pdfjsLib } = window;

            pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

            // Load PDF document
            pdfjsLib.getDocument(pdfUrl).promise.then((pdf) => {
              const imageContainer = document.getElementById('imageContainer');
              const pageNumber = 1; // Display the first page only

              // Get the first page
              pdf.getPage(pageNumber).then((page) => {

                // Create a canvas element to render the page
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                const viewport = page.getViewport({ scale: 2 });
                canvas.height = viewport.height;
                canvas.width = viewport.width;

                // Render the first page to the canvas
                const renderContext = {
                  canvasContext: context,
                  viewport: viewport,
                };
                page.render(renderContext).promise.then(() => {

                  // Convert the canvas to a data URL (image)
                  const imageDataURL = canvas.toDataURL();

                  // Create an img element and set its source to the data URL
                  const imgElement = document.createElement('img');
                  imgElement.src = imageDataURL;
                  imgElement.alt = 'Page 1';

                  // Append the img element to the container
                  imageContainer.appendChild(imgElement);
                });
              });
            }).catch((error) => {
              console.error('Error loading PDF:', error);
            });
          </script>
        </body>
        </html>
  `;
        newtab.document.write(html);
      }

      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    }
  }

  return (
    <>
      {rowData.length > 0 ? (
        <>
          <Menu
            className="[&_.p-menu-list]:!px-0"
            style={{
              width: "100%",
              background: "inherit",
              border: "none",
              paddingLeft: 0,
              paddingRight: 0,
            }}
            model={listaBoletos}
          />
          {/* <button className='bg-[#001d74] w-[5vh] h-[5vh] text-slate-50 p-[0.9vh] rounded-full
        hover:bg-gradient-to-b hover:from-[#0000ff] hover:to-[#0040ff] hover:scale-110
        hover:shadow-[0.5px_0.5px_1px_1px_#4300fa85] transition duration-100
        font-lato font-bold grid ' 
        onClick={(e) => {handleSelection(e)}}
        type="button"
        >
          <i className='pi pi-download' style={{fontSize:"2.5vh",marginTop:"0.3vh"}}></i>
        </button> */}
        </>
      ) : (
        <>
          {" "}
          <h5 className="font-lato-bold">Feita com cartão</h5>
        </>
      )}
    </>
  );
}

export const termoBody = (rowData) => {
  async function downloadTermo(e) {
    const data = await PegaTermo(rowData.cobranca_id);
    //console.log(data)
    const binary = Buffer.from(data.replace(/\s/g, ""), "base64").toString("binary");
    const len = binary.length;
    const buffer = new ArrayBuffer(len);
    //console.log(binary)
    let view = new Uint8Array(buffer);

    for (let i = 0; i < len; i++) {
      view[i] = binary.charCodeAt(i);
    }
    const blob = new Blob([view], { type: "aplication/pdf" });
    const boleto = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = boleto;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.download = `Termo-baixado-em:${format(new Date(), "dd/MM/yyyy")}.pdf`;
    document.body.appendChild(link);
    link.click();
    setTimeout(function () {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
    }, 100);
  }

  return (
    <button
      className="bg-[#001d74] w-[5vh] h-[5vh] text-slate-50 p-[0.9vh] rounded-full
    hover:bg-gradient-to-b hover:from-[#0000ff] hover:to-[#0040ff] hover:scale-110
    hover:shadow-[0.5px_0.5px_1px_1px_#4300fa85] transition duration-100
    font-lato font-bold grid "
      onClick={(e) => {
        downloadTermo(e);
      }}
      type="button"
      data-pr-tooltip="Sair"
    >
      <i className="pi pi-download" style={{ fontSize: "2.5vh", marginTop: "0.3vh" }}></i>
    </button>
  );
};